<template>
    <div id="sidebar-wrapper" :style="sideBarStyle">
        <main-place />
        <ul class="sidebar-nav">
        <router-link v-for="item in userMenu" :key="item.linkTo"
            @click.native="closeMenu"
            tag="li"
            :to="{ name: item.linkTo }"
            >
            <a>
                <i class="material-icons" >{{ item.iconType }}</i>
                {{ item.text }}
            </a>
        </router-link>
        </ul>
    </div>
</template>
<script>
import menu from '@/service/menu'
import userService from '@/service/userService'
import un from 'underscore'

export default {
    name: "LeftMenu",
    data: () => ({
        menuOpened: false,
        menu: menu
    }),
    created() {
        this.$eventHub.$on('hamburgerClicked', this.onHamburgerClicked);
    },
    beforeDestroy() {
        this.$eventHub.$off('hamburgerClicked');
    },
    methods: {
        onHamburgerClicked(data) {
        this.menuOpened = data.menuOpened;
        },
        closeMenu() {
        this.menuOpened = false;
        this.$eventHub.$emit("menuClosed", {});
        }
    },
    computed: {
        isAdmin() {
            return userService.isAdmin();
        },
        logged () {
            return userService.isLogged()
        },
        sideBarStyle() {
            return this.menuOpened ? "display: block; z-index:10;" : "";
        },
        userMenu() {
            const isAdmin = userService.isAdmin()
            const isUserPhoneServices = userService.isUserPhoneServices()
            return un.filter(this.menu, menuItem => {
                if (isAdmin) {
                    return true
                }
                if (isUserPhoneServices) {
                    return menuItem.linkTo === "servicesList" || menuItem.linkTo === "servicesEdit"
                }
                return menuItem.show(isAdmin)
            })
        }
    }
}
</script>
<style scoped lang="scss">

    #sidebar-wrapper {
        overflow: auto;
    }

</style>


// WEBPACK FOOTER //
// src/components/place/LeftMenu.vue